import {
  Box,
  Button,
  Fade,
  FormControl,
  FormControlLabel,
  FormLabel,
  List,
  ListItem,
  Popover,
  Popper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "styles/component/Popper.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import MultiSelect from "components/MultiSelect/MultiSelect";
import { Link } from "react-router-dom";
import asset from "json/assets";
import eventEmitter from "services/event.emitter";
import events from "json/events";
import useNotiStack from "hooks/useNotistack";

import {
  useAddedShapedStatus,
  useEditableArea,
  useMapShapeData,
  useSelectedZone,
  useSelectedZoneType,
} from "hooks/MapDetails";
import { singleShapeElements } from "json/constants";
import { useDispatch } from "react-redux";
import { setAddedShapeStatus } from "redux/MapSlice";

function PopperComponent(props) {
  const {
    children,
    onClose,
    handleOnClose,
    open,
    id,
    anchorOpen,
    positionLeftTop = true,
    title,
  } = props;
  const { toastWarning } = useNotiStack();
  const [anchorEl, setAnchorEl] = useState(null);
  const zoneType = useSelectedZoneType();
  const editableArea = useEditableArea();
  const addedShapeStatus = useAddedShapedStatus();
  const shapeData = useMapShapeData();
  const selectedZone = useSelectedZone();

  const openAnchor = Boolean(anchorEl);
  const idNew = openAnchor ? "simple-popover-any" : undefined;

  const [addShapeDisabled, setAddshapeDisabled] = useState(false);

  const emitDrawPolygon = () => {
    let z = zoneType;
    if (zoneType === "line") {
      z = "polyline";
    }

    eventEmitter.emit(events.draw, { event: "add", type: z });

    //filter by selected zone type : polygon,marker,polyline etc.
    // eventEmitter.emit(events.draw, { event: "add", type: "polygon" });
  };
const dispatch=useDispatch()
  const handleClick = (e) => {
if(!editableArea){

  if (addShapeDisabled) {
    if (selectedZone === "facilityMarker") {
      toastWarning("You can not add more than one facility marker");
    } else if (selectedZone === "perimeter") {
      toastWarning("You can not add more than one perimeter");
    }
    return;
  }
  dispatch(setAddedShapeStatus('drawing'))
  emitDrawPolygon();

}
else{
  toastWarning("Can not add shape in edit mode.")
}

    // if (!editableArea && addedShapeStatus === "idle") {
    //   // can not initate add when edit and draw is enabled
    //   emitDrawPolygon();
    // }
    // else{
    //   toastWarning("Edit/Drawing Mode is already enabled");
    // }

  };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  useEffect(() => {
    if (
     ( addedShapeStatus === "idle" &&
      singleShapeElements?.includes(selectedZone) &&
      shapeData[`${selectedZone}`] &&
      shapeData[`${selectedZone}`]?.length > 0)|| addedShapeStatus==='drawing' 
      // plus icon does not work if already drawing is enabled
    ) {
      // return;
      setAddshapeDisabled(true);
    } else {
      setAddshapeDisabled(false);
    }
  }, [
    selectedZone,
    addedShapeStatus,
    shapeData,
    shapeData[`${selectedZone}`]?.length,
  ]);

  return (
    <Popper
      id={id}
      open={open}
      anchorEl={anchorOpen}
      onClose={onClose}
      // anchorOrigin={{
      //   vertical: positionLeftTop ? "top" : "bottom",
      //   horizontal: positionLeftTop ? "left" : "left",
      // }}
      sx={{ margin: "0px 7px !important" }}
      // transformOrigin={{
      //   vertical: "top",
      //   horizontal: "right",
      // }}
      placement="left-start"
      className={positionLeftTop ? "" : `${styles.bottom_popover}`}
      transition
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps}>
          <Box className={styles.poover_content}>
            <Box className={styles.poover_head}>
              <Typography variant="h5">{title}</Typography>
              <List>
                <ListItem>
                  <Button
                    onClick={handleClick}
                    aria-describedby={idNew}
                    // disabled={addShapeDisabled}
                  >
                    <img src={asset.plus} alt="" />
                  </Button>
                  {/* <Popover
                  id={idNew}
                  open={openAnchor}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: positionLeftTop ? "top" : "bottom",
                    horizontal: positionLeftTop ? "left" : "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  className={styles.sub_popover}
                >
                  <Box className={styles.poover_content}>
                    <Box className={styles.poover_head}>
                      <Typography variant="h5">Add Marker</Typography>
                      <List>
                        <ListItem>
                          <Button onClick={handleClose}>
                          <img src={asset.close} alt="" />
                          </Button>
                        </ListItem>
                      </List>
                    </Box>
                    <Box className={styles.popover_body_new}>
                      <MultiSelect />
                      <Box className={styles.popover_ftr}>
                        <Link to={"#"} className={styles.blue_btn}>
                          Save
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                </Popover> */}
                </ListItem>
                <ListItem>
                  <Button aria-describedby={id} onClick={handleOnClose}>
                    <img src={asset.close} alt="" />
                  </Button>
                </ListItem>
              </List>
            </Box>
            <Box className={styles.popover_body}>{children}</Box>
          </Box>
        </Fade>
      )}
    </Popper>
  );
}

export default PopperComponent;
